



























































import Vue from 'vue';
import _ from '../../utils';

export default Vue.extend({
  props: {
    value: { default: true, type: Boolean },
    overlay: { default: false, type: Boolean },
    blur: { default: false, type: Boolean },
    color: { default: 'surface-1', type: String },
    elevation: { default: 1, type: [String, Number] },
    flat: { default: false, type: Boolean },
    minifiable: { default: false, type: Boolean },
    minified: { default: false, type: Boolean },
    right: { default: false, type: Boolean },
    bottom: { default: false, type: Boolean },
    top: { default: false, type: Boolean },
  },
  data: () => ({
    internalVisible: false,
    innerMinifed: false,
  }),
  computed: {
    hasFooter(): boolean {
      return _.component.hasSlot(this, 'drawer-footer-actions')
        || _.component.hasSlot(this, 'drawer-footer')
        || this.isMinifiable;
    },
    isMinifiable(): boolean {
      return this.minifiable && !this.top && !this.bottom;
    },
    chevronIcon() {
      if (this.right) {
        return 'chevron_right';
      }
      if (this.top) {
        return 'expand_less';
      }
      if (this.bottom) {
        return 'expand_more';
      }
      return 'chevron_left';
    },
    hasHeader(): boolean {
      return this.hasHeaderSubtitle || this.hasHeaderImage || this.hasHeaderTitle || this.hasCustomHeader;
    },
    hasHeaderSubtitle(): boolean {
      return this._.component.hasSlot(this, 'drawer-header-subtitle');
    },
    hasHeaderTitle(): boolean {
      return this._.component.hasSlot(this, 'drawer-header-title');
    },
    hasHeaderImage(): boolean {
      return this._.component.hasSlot(this, 'drawer-header-image');
    },
    hasCustomHeader(): boolean {
      return this._.component.hasSlot(this, 'drawer-header');
    },
    hasMinifiableHeader(): boolean {
      if (this.hasCustomHeader) {
        return false;
      }
      return this.hasHeaderImage;
    },
    overlayBackgroundVisible(): boolean {
      return this.overlay && this.internalVisible;
    },
    classListWrapper(): Record<string, boolean> {
      return {
        left: !this.right && !this.top && !this.bottom,
        right: this.right,
        top: this.top,
        bottom: this.bottom,
      };
    },
    classList(): Record<string, boolean> {
      return {
        'p-side-drawer': true,
        [`color-${this.color}`]: true,
        [`elevation-${this.elevation}`]: !this.flat,
        minified: this.minified,
        visible: this.internalVisible,
        overlay: this.overlay,
        'minifiable-header': this.hasMinifiableHeader,
        blur: this.blur,
      };
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.internalVisible = newValue;
        if (this.$el) {
          // Only store if the side-drawer has been mounted
          // this.setStoredState('visible', this.internalVisible);
        }
      },
      immediate: true,
    },
    minifed: {
      immediate: true,
      handler() {
        this.innerMinifed = this.minified;
      },
    },
  },
  beforeMount() {
    // const isMinifed = this.getStoredState<boolean>('minifed');
    // this.setMinified(isMinifed ?? this.minified);
    // const isVisible = this.getStoredState<boolean>('visible');
    // this.setVisibility(isVisible ?? this.internalVisible);
  },
  methods: {
    toggleMinifed() {
      this.setMinified(!this.innerMinifed);
    },
    setMinified(isMinified: boolean) {
      this.innerMinifed = isMinified;
      // this.setStoredState('minifed', isMinified);
      this.$emit('update:minified', isMinified);
    },
    getStoreName(name: string) {
      const uiPathId = _.component.getComponentUILocationId(this);
      return `SideDrawer_${name}_${uiPathId}`;
    },
    // getStoredState<T = any>(name: string) {
    //   return this.$localStorage.get<T>(this.getStoreName(name));
    // },
    // setStoredState(name: string, value: any) {
    //   this.$localStorage.set(this.getStoreName(name), value);
    // },
    toggleMinified() {
      this.setMinified(!this.minified);
    },
    setVisibility(isVisible: boolean) {
      this.internalVisible = isVisible;
      this.$emit('input', this.internalVisible);
    },
    toggleVisbility() {
      this.setVisibility(!this.internalVisible);
    },
  },
});
